import deAudiobook from "../client/i18n/de/audiobook.json";
import deCasting from "../client/i18n/de/casting.json";
import deChapters from "../client/i18n/de/chapters.json";
// The one catalogue table, shared by the SPA and the server's i18next
// instance. The JSON lives under src/client/i18n/{de,en}/ (screen packages
// own their namespace file there); this module is the only place that lists
// them, and scripts/check-i18n.ts fails when a file on disk is missing here.
import deCommon from "../client/i18n/de/common.json";
import deComponents from "../client/i18n/de/components.json";
import deDashboard from "../client/i18n/de/dashboard.json";
import deErrors from "../client/i18n/de/errors.json";
import deNav from "../client/i18n/de/nav.json";
import deOverview from "../client/i18n/de/overview.json";
import deProgress from "../client/i18n/de/progress.json";
import deRender from "../client/i18n/de/render.json";
import deReview from "../client/i18n/de/review.json";
import deSignin from "../client/i18n/de/signin.json";
import deStates from "../client/i18n/de/states.json";
import deStyleSheet from "../client/i18n/de/stylesheet.json";
import enAudiobook from "../client/i18n/en/audiobook.json";
import enCasting from "../client/i18n/en/casting.json";
import enChapters from "../client/i18n/en/chapters.json";
import enCommon from "../client/i18n/en/common.json";
import enComponents from "../client/i18n/en/components.json";
import enDashboard from "../client/i18n/en/dashboard.json";
import enErrors from "../client/i18n/en/errors.json";
import enNav from "../client/i18n/en/nav.json";
import enOverview from "../client/i18n/en/overview.json";
import enProgress from "../client/i18n/en/progress.json";
import enRender from "../client/i18n/en/render.json";
import enReview from "../client/i18n/en/review.json";
import enSignin from "../client/i18n/en/signin.json";
import enStates from "../client/i18n/en/states.json";
import enStyleSheet from "../client/i18n/en/stylesheet.json";

export const NAMESPACES = [
  "audiobook",
  "progress",
  "render",
  "casting",
  "common",
  "chapters",
  "stylesheet",
  "nav",
  "errors",
  "states",
  "signin",
  "dashboard",
  "overview",
  "review",
  "components",
] as const;
export type Namespace = (typeof NAMESPACES)[number];
export const DEFAULT_NAMESPACE: Namespace = "common";

export const resources = {
  de: {
    audiobook: deAudiobook,
    progress: deProgress,
    render: deRender,
    casting: deCasting,
    common: deCommon,
    stylesheet: deStyleSheet,
    chapters: deChapters,
    nav: deNav,
    errors: deErrors,
    states: deStates,
    signin: deSignin,
    dashboard: deDashboard,
    overview: deOverview,
    review: deReview,
    components: deComponents,
  },
  en: {
    audiobook: enAudiobook,
    progress: enProgress,
    render: enRender,
    casting: enCasting,
    common: enCommon,
    stylesheet: enStyleSheet,
    chapters: enChapters,
    nav: enNav,
    errors: enErrors,
    states: enStates,
    signin: enSignin,
    dashboard: enDashboard,
    overview: enOverview,
    review: enReview,
    components: enComponents,
  },
} as const;

/**
 * Chapter labels the screens show that are not ChapterStates of the contract:
 * a render row waiting for its turn, Chapter Audio superseded by an edit, a
 * render the Author stopped. They live under states:chapter.* next to the
 * contract states so one lookup covers a row.
 */
export const CHAPTER_DISPLAY_STATES = ["queued", "stale", "cancelled"] as const;
export type ChapterDisplayState = (typeof CHAPTER_DISPLAY_STATES)[number];
